import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  saveGenericName,
} from "../genericNameThunks";

import {
  setSelectedGenericName,
  setIsEditGenericName,
} from "../genericNameSlice";

import { getAccessType } from "../../../lib/functions";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateGenericNameForm = () => {

  const { modal } = App.useApp();

  const dispatch = useDispatch();

  const screens = useBreakpoint();

  const navigate = useNavigate();

  const [form] = useForm();

  let [access_type, access_type_set] =
    useState("");

  useEffect(() => {

    const access =
      getAccessType("generic_name");

    access_type_set(access);

  }, []);

  const {
    isEditGenericName,
    selectedGenericName,
  } = useSelector(
    (state) => state.genericNames
  );

  useEffect(() => {

    if (
      isEditGenericName &&
      selectedGenericName
    ) {

      form.setFieldsValue(
        selectedGenericName
      );

    } else {

      form.resetFields();
    }

  }, [
    isEditGenericName,
    selectedGenericName,
    form,
  ]);

  const handleCancel = () => {

    dispatch(
      setSelectedGenericName(null)
    );

    dispatch(
      setIsEditGenericName(false)
    );

    navigate(-1);
  };

  const handleSave = async (values) => {

    try {

      await dispatch(
        saveGenericName({
          ...values,

          action:
            isEditGenericName
              ? "update"
              : "create",

          generic_name_id:
            selectedGenericName?.generic_name_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditGenericName
          ? "Generic Name updated successfully"
          : "Generic Name created successfully",
      });

      dispatch(
        setSelectedGenericName(null)
      );

      dispatch(
        setIsEditGenericName(false)
      );

      navigate(
        "/inventory/generic-names"
      );

    } catch (error) {

      modal.warning({
        title:
          error.message || "Save failed",
      });
    }
  };

  return (
    <div
      className="generic-name-form"
      style={{ padding: !screens.md ? "0 16px" : 0, overflowX: "hidden" }}
    >

      <Title
        level={!screens.md ? 4 : 2}
        style={{
          marginBottom: "32px",
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        {isEditGenericName
          ? "Update Generic Name"
          : "Create New Generic Name"}
      </Title>

      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        colon={false}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >

        <Flex
          gap={
            !screens.md || !screens.xl
              ? 10
              : 80
          }

          justify="center"

          style={{
            flexDirection:
              !screens.md || !screens.xl
                ? "column"
                : "row",

            width: "100%",
            marginBottom: "24px",
          }}
        >

          <Flex
            vertical
            gap={10}

            style={{
              width:
                !screens.md || !screens.xl
                  ? "100%"
                  : "40%",
            }}
          >

            <Form.Item
              label="Generic Name"
              name="generic_name"

              rules={[
                {
                  required: true,
                  message:
                    "Please enter generic name",
                },
              ]}
            >

              <InputField
                placeholder="Enter Generic Name"
              />

            </Form.Item>

          </Flex>

        </Flex>

        <Flex
          style={{
            marginBottom: "32px",
            width: "25%",
          }}

          gap={32}
        >

          <Button
            size="large"
            shape="default"
            onClick={handleCancel}
            className="traic-button"
          >
            Back
          </Button>

          {access_type == "WRITE" && (
            <>

              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="traic-button"
              >
                {isEditGenericName
                  ? "Update"
                  : "Save"}
              </Button>

            </>
          )}

        </Flex>

      </Form>

    </div>
  );
};

export default CreateGenericNameForm;